<div class="col full-height layout-column" *ngIf="mutableRoute">

  <app-routes-panel-list-item [route]="mutableRoute"
                              [settings]="settings.routes"
                              [isVisible]="visibleKeys[mutableRoute.id]"
                              [canClose]="true"
                              [canShow]="true"
                              [canLock]="true"
                              (onToggleVisible)="onToggleVisible.emit($event)"
                              (onChangeRouteResource)="onSelectRouteResource.emit({route: $event.route, event: $event.event})"
                              (onLockRouteChange)="onLockRouteChange.emit($event)"
                              (onClose)="onSelect.emit()">

  </app-routes-panel-list-item>

  <div class="flex layout-column dndList overflow-auto margin-top-5"
       cdkDropList
       [cdkDropListData]="tasks"
       id="{{panel.id + '-drilldown'}}"
       [cdkDropListConnectedTo]="allPanelIds"
       [cdkDropListDisabled]="!!isLoading || route.isBlockedByUser"
       [cdkDropListSortPredicate]="sortPredicate"
       (cdkDropListEntered)="enter($event)"
       (cdkDropListDropped)="drop($event)">

    <!--    <div class="route-item-test"-->
    <!--         *ngFor="let task of route.taskListExt;let index = index"-->
    <!--         cdkDrag-->
    <!--         [cdkDragData]="task">-->
    <!--      {{task.id}}-->
    <!--    </div>-->

    <div class="layout-column gap-10" *ngFor="let task of tasks; let index = index">

      <app-routes-panel-route-view-task-item class="flex"
                                             [task]="task"
                                             [index]="index + taskIndexOffset"
                                             [isSelected]="selectedKeys[task.id]"
                                             [route]="mutableRoute"
                                             [settings]="settings.route"
                                             [isHighlighted]="localHighlightedTaskIds.has(task.id) || highlightedActivity?.id === task.id"
                                             [class.highlighted]="localHighlightedTaskIds.has(task.id) || highlightedActivity?.id === task.id"
                                             [relations]="relationsMap[task.id]"
                                             cdkDrag
                                             [cdkDragDisabled]="task.taskType === TaskType.Internal || !!isLoading || route.isBlockedByUser"
                                             [cdkDragData]="task"
                                             (onToggle)="onSelectedChange(task, $event)"
                                             (onSplitByPackages)="onSplitByPackages.emit($event)"
                                             (onHoverTask)="onHoverTask($event)"
                                             (onRelationsClick)="onRelationsClick($event, task)">

        <div cdkDragHandle>
          <bringoz-icon iconName="drag" class="secondary-100"></bringoz-icon>
        </div>

        <div *ngIf="selectedServiceIds?.length > 1 && selectedKeys[task.id]">
          <div *cdkDragPreview id="app-planning-draft-jobs-panel-editable-list-preview-drag-multiple-jobs-container">
            {{ 'DRAGGING_X_ITEMS.JOBS' | translate:{X: selectedServiceIds.length} }}
          </div>
        </div>

      </app-routes-panel-route-view-task-item>
    </div>


<!--    <app-routes-panel-route-view-task-item *ngFor="let task of tasks;let index = index"-->
<!--                                           [task]="task"-->
<!--                                           [index]="index + 1"-->
<!--                                           [route]="mutableRoute"-->
<!--                                           [settings]="settings.route"-->
<!--                                           [highlightedTask]="highlightedTask"-->
<!--                                           cdkDrag-->
<!--                                           [cdkDragDisabled]="task.taskType === 'Internal'"-->
<!--                                           [cdkDragData]="task">-->

<!--    </app-routes-panel-route-view-task-item>-->

    <ng-template cdkDropListPlaceholder>
      <div class="placeholder">Drop here</div>
    </ng-template>

  </div>

  <app-bringoz-linear-progress *ngIf="loading$ | async as loading"></app-bringoz-linear-progress>
</div>


<!--<div-->
<!--  cdkDropList-->
<!--  class="example-list"-->
<!--  (cdkDropListDropped)="drop($event)"-->
<!--  [cdkDropListSortPredicate]="sortPredicate"-->
<!--&gt;-->
<!--  @for (number of numbers; track number) {-->
<!--  <div class="example-box" [cdkDragData]="number" cdkDrag>{{number}}</div>-->
<!--  }-->
<!--</div>-->
